import { Dialog, DialogProps } from '@mui/material';

export interface GlobalDialogProps {
    open: boolean;
    onClose: () => void;
    Component: React.ReactNode;
    maxWidth?: DialogProps['maxWidth'];
}

const GlobalDialog = (props: GlobalDialogProps) => {
    const { onClose, open, Component, maxWidth } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog PaperProps={{ sx: { p: 0, maxWidth: '100%' } }} onClose={handleClose} maxWidth={maxWidth} open={open}>
            {Component}
        </Dialog>
    );
};
export default GlobalDialog;
